<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerRight from '../components/oferta/TopBannerRight.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue'; 
    const ProgramaModelo = defineAsyncComponent(() => import('../components/oferta/ProgramaModelo.vue')); 
const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue'));
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ;
    const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const LicExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/LicExcelenciaAcadem.vue')) ; 
    // const CasosExito = defineAsyncComponent(() => import('../components/oferta/CasosExitoPrime.vue')); 
    
</script>

<template>
    <TopBannerRight :img="'background-image: url(../../pagesImages/diseno.jpg);'" :nivel="'Licenciatura en'" :carrera="'Dise&ntilde;o Gr&aacute;fico'" :frase="'Aprende las reglas como un profesional, para que puedas romperlas como un artista'" :autor="'Pablo Picasso'" />
    <FormarBloque :img="'../../pagesImages/diseno-escolarizado.jpg'" :link="'/requisitos-licenciatura'" alt="Licenciada en Diseño Universidad Humanitas" :frase="'Diseñar es transformar ideas en soluciones visuales que inspiran, comunican y generan impacto en la sociedad'" :testo1="'Formamos profesionales con los conocimientos, habilidades y actitudes necesarias para desarrollar proyectos de diseño que integren creatividad, técnica y teoría de la imagen.'" :testo2="'Impulsamos la innovación visual desde una perspectiva crítica y funcional, combinando el dominio de herramientas digitales con fundamentos estéticos, narrativos y comunicacionales.'" :testo3="'Este programa está dirigido a aspirantes interesados en la Comunicación gráfica y en la creación de estrategias visuales innovadoras. A través del diseño, podrán generar, implementar y operar soluciones que respondan de manera creativa a los desafíos del contexto social, cultural y político en el que están inmersos los consumidores.'"/>
    <div class="flex items-center justify-center mb-12">
    </div>
    <ProgramaModelo :escolarizado="true"/>
    <VerModelo esco="/pagesImages/Programas/Licenciatura/lic-diseno-grafico-escolarizado-B.webp"
    :escoT="true"
    :ejecT="false"
    :virtT="false" />
    
    <EgresadosHuma :types="'Licenciatura Dise'" class="mb-16" />
   
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Campus Humanitas que </span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">cuentan con esta licenciatura</span>
                        </h2>
                        <ul class="list-disc pl-8 mb-4">
                            <li>Cancún</li>
                            <li>Guadalajara</li>
                            <li>Madín</li>
                            <li>Mérida</li>
                            <li>Querétaro</li>
                            <li>Reyes</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/fachada-campus-madin.webp" alt="Imagen de fachada de Campus Madín" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
    </section>

    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/licenciaturas-estructura.webp" alt="Estructura académica en Universidad Humanita" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques temáticos):</span>
                        </h2>
                        <ul class="list-disc pl-3 hyphens-auto">
                            <li><b>Fundamentos del Diseño:</b> Creatividad, dibujo, geometría II, Diseño y Diseño Industrial, teoría de la imagen e ilustración.</li>
                            <li><b>Herramientas técnicas y digitales:</b> Diseño vectorial, taller digital I, II y III, Diseño digital, II y III, técnicas de impresión, gráficos digitales, Diseño y administración WEB.</li>
                            <li><b>Identidad y marca:</b> Identidad gráfica, Imagen corporativa, Imagen BTL, gerencia de marca y campañas de publicidad.</li>
                            <li><b>Diseño Aplicado:</b> Empaque y embalaje, desarrollo de prototipos, diseño editorial, diseño ambiental, señalización, diseño aplicado al espacio, estands, producción audiovisual, guionismo y post-producción.</li>
                            <li><b>Marketing y Comunicación:</b> Comercialización estratégica, redacción publicitaria, Marketing digital, análisis del producto/servicio, Mercadotecnia y gestión de proyectos de Diseño.</li>
                            <li><b>Teoría y Metodología:</b> Métodos de investigación para el diseño, Semiótica, propiedad intelectual y registro de patentes.</li>
                            <li><b>Idiomas:</b> Inglés I, II, III, IV, V, VI, VII, VIII. Solo en modelo escolarizado.</li>
                        </ul>
                    </div>
                </div>
			</div>
		</div>
	</section>
    <CalendarioOferta nombre="Licenciatura en Diseño Gráfico" :titulo="'Calendario de la modalidad Escolarizada'" :subtitulo="'Consulta la disponibilidad de tu licenciatura.'"
  :inicios="[true, true, false, false, true, true, false, false]"></CalendarioOferta>
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-8 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <PoliticaIA />
</template>

<style scoped>
</style>